export type EpsonPrintQuality = "D" | "S" | "N" | "Q" | "M";

/**
 * Instellingen voor labels die via de Winfakt Label Renderer (Vercel) naar een Epson ColorWorks gaan.
 * `Fields` koppelt elk templateveld (bv. "referentie", "rijen.0.code") aan een JS-template zoals in de ZPL-editor:
 * `${value.ProductSku}`.
 */
export class EpsonSettings {
	Enabled:boolean = false;
	ServiceUrl:string = "";
	Template:string = "";
	Host:string = "";
	Port:number = 9100;
	Quality:EpsonPrintQuality = "N";
	Fields:{[key:string]:string} = {};

	public constructor(data?:any){
		if (!data) return;
		this.Enabled = data.Enabled || false;
		this.ServiceUrl = data.ServiceUrl || "";
		this.Template = data.Template || "";
		this.Host = data.Host || "";
		this.Port = data.Port || 9100;
		this.Quality = data.Quality || "N";
		this.Fields = {...(data.Fields || {})};
	}

	public getServiceOrigin():string {
		try {
			return new URL(this.ServiceUrl).origin;
		} catch (err) {
			return "";
		}
	}

	public getJSON(){
		return {
			Enabled: this.Enabled,
			ServiceUrl: this.ServiceUrl,
			Template: this.Template,
			Host: this.Host,
			Port: this.Port,
			Quality: this.Quality,
			Fields: {...this.Fields}
		};
	}
}
